// DEVELOPED BY TAHA HUSSAIN
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './data.service';
import { AppConfig } from './config/app.config';

@Injectable({
  providedIn: 'root'
})

export class TenantFieldSetupService extends DataService{

  constructor(appConfig:AppConfig,http: HttpClient) {
    super(appConfig,http);
  }
}
